import { Button } from './Button'

interface Props {
  onSizeWorkload: () => void
  onTalkToArchitect: () => void
}

const TRUST_STRIP = [
  'FedRAMP High Ready · IL5-aligned · pursuing Authorization',
  'Single operator · single contract',
  'Equinix data centers · sovereign U.S. infrastructure',
  'Predictable monthly pricing · no Broadcom math',
]

export function Hero({ onSizeWorkload, onTalkToArchitect }: Props) {
  return (
    <section id="top" className="bg-hero-gradient text-white pt-16">
      <div className="mx-auto max-w-7xl px-6 pt-16 pb-20 lg:pt-24 lg:pb-28">
        <div className="max-w-4xl">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold leading-tight tracking-tight">
            CyLogic operates a sovereign cloud you{' '}
            <span className="text-mint">subscribe to</span>, not assemble.
          </h1>
          <p className="mt-8 text-lg sm:text-xl text-white/85 max-w-3xl leading-relaxed">
            Federal contractors and regulated enterprises get a managed VCF-native private
            cloud running in Equinix data centers under a FedRAMP-aligned boundary — one
            contract, one operator, one monthly invoice instead of a stack of vendors,
            licenses, and FTEs to assemble.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Button size="lg" onClick={onSizeWorkload} className="bg-mint text-navy hover:bg-mint/90">
              Size your workload →
            </Button>
            <button
              onClick={onTalkToArchitect}
              className="text-white/85 hover:text-mint underline-offset-4 hover:underline transition-colors text-base"
            >
              Talk to a CyLogic architect
            </button>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/15">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-4">
            {TRUST_STRIP.map((item) => (
              <div key={item} className="font-data text-xs text-white/85 tracking-wide uppercase">
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
